import { useCallback, useMemo } from "react";
import { analyticsClient } from "./client";
import { EventName, EventProps } from "./events";

/**
 * Component-facing analytics API. Components never import mixpanel-browser directly —
 * always go through this hook so every event stays type-checked against the catalogue (FR-016).
 *
 * `track` is memoised with an empty dependency list (the underlying `analyticsClient.track`
 * is a stable module singleton), so consumers can safely include it in `useEffect` dep arrays
 * without triggering re-runs or stale-closure bugs. This lets us drop the
 * `eslint-disable-next-line react-hooks/exhaustive-deps` pattern in call sites over time.
 */
export function useAnalytics() {
  const track = useCallback(<E extends EventName>(event: E, props?: EventProps<E>): void => {
    analyticsClient.track(event, props);
  }, []);
  return useMemo(() => ({ track }), [track]);
}
